<div class="obd-page-header">
  <h1><fa-icon class="obd-icon-header" [icon]="faCar"></fa-icon> <span class="font-weight-semibold">OBD Details | {{deviceId}} Reports</span></h1>
</div>

<div class="obd-breadcrumb">
  <div class="d-flex">
    <a href="/" class="breadcrumb-item"><fa-icon  class="obd-icon" [icon]="faHome"></fa-icon> Home</a>
    <a href="/obd-list" class="breadcrumb-item"><span class="breadcrumb-item">OBD List</span></a>
    <span class="breadcrumb-item active">OBD Details</span>		
  </div>
</div>

<div class="obd-page-content">
  <div class="row">
    <div class="col-lg-4 col-md-6">
      <div class="card">
        <div *ngIf="cardLoader1">
          <div class="loading">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
        <div class="obd-title">Vehicle Location <a (click)="refreshVehicleLocation()" class="float-right"><fa-icon class="obd-icon" [icon]="faSync"></fa-icon></a></div>
        <div class="obd-card-body">
          <div><label>latitude</label> : {{vehicleLocationModel.latitude}}</div>
          <div><label>longitude</label>: {{vehicleLocationModel.longitude}}</div>
          <div><label>location</label>: {{vehicleLocationModel.location}}</div>
          <div><label>Error Message</label>: {{vehicleLocationModel.errorMessage}}</div>
          <div><label>Timestamp</label>: {{vehicleLocationModel.timestamp}}</div>
        </div> 
      </div>
    </div>

    <div class="col-lg-4 pr-lg-0 col-md-6"> 
      <div class="card">
        <div *ngIf="cardLoader2">
          <div class="loading">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
        <div class="obd-title">Fuel Consumption  <a (click)="refreshFuelConsumption()" class="float-right"><fa-icon class="obd-icon" [icon]="faSync"></fa-icon></a></div>
        <div class="obd-card-body">
          <div><label>Total Accumiliated Fuel Consumption</label> : {{fuelConsumptionModel.totalAccumiliatedFuelConsumption}}</div>
          <div><label>Current Trip Fuel Consumption</label>: {{fuelConsumptionModel.currentTripFuelConsumption}}</div>
          <div><label>Fuel ConsumptionUnit</label>: {{fuelConsumptionModel.fuelConsumptionUnit}}</div>
          <div><label>Timestamp</label>: {{fuelConsumptionModel.timestamp}}</div>
        </div> 
      </div>
    </div>
    <div class="col-lg-4 pr-lg-0 col-md-6">
      <div class="card">
        <div *ngIf="cardLoader3">
          <div class="loading">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
        <div class="obd-title">Vehicle Mileage <a (click)="refreshVehicleMileage()" class="float-right"><fa-icon class="obd-icon" [icon]="faSync"></fa-icon></a></div>
        <div class="obd-card-body">
          <div><label>Total Accumiliated Mileage</label> : {{vehicleMileageModel.totalAccumiliatedMileage}}</div>
          <div><label>Current Trip Mileage</label>: {{vehicleMileageModel.currentTripMileage}}</div>
          <div><label>Mileage Unit</label>: {{vehicleMileageModel.mileageUnit}}</div>
          <div><label>Timestamp</label>: {{vehicleMileageModel.timestamp}}</div>
        </div> 
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-4 col-md-6">
      <div class="card">
        <div *ngIf="cardLoader4">
          <div class="loading">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
        <div class="obd-title">Fuel Level <a (click)="refreshFuelLevel()" class="float-right"><fa-icon class="obd-icon" [icon]="faSync"></fa-icon></a></div>
        <div class="obd-card-body">
          <div><label>Error Message</label> : {{fuelLevelModel.errorMessage}}</div>
        </div> 
      </div>
    </div>
    <div class="col-lg-4 pr-lg-0 col-md-6">
      <div class="card">
        <div *ngIf="cardLoader5">
          <div class="loading">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
        <div class="obd-title">Control Module Voltage <a (click)="refreshControlModuleVoltage()" class="float-right"><fa-icon class="obd-icon" [icon]="faSync"></fa-icon></a></div>
        <div class="obd-card-body">
          <div><label>Error Message</label> : {{controlModuleVoltageModel.errorMessage}}</div>
        </div> 
      </div>
    </div>
    <div class="col-lg-4 pr-lg-0 col-md-6">
      <div class="card">
        <div *ngIf="cardLoader6">
          <div class="loading">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
        <div class="obd-title">Vehicle Engine Status <a (click)="refreshVehicleEngineStatus()" class="float-right"><fa-icon class="obd-icon" [icon]="faSync"></fa-icon></a></div>
        <div class="obd-card-body">
          <div><label>Engine Status</label> : {{vehicleEngineStatusModel.engineStatus}}</div>
          <div><label>Timestamp</label>: {{vehicleEngineStatusModel.timestamp}}</div>
        </div> 
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-4 col-md-6">
      <div class="card">
        <div *ngIf="cardLoader7">
          <div class="loading">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
        <div class="obd-title">Engine Coolant Temperature <a (click)="refreshEngineCoolantTemperature()" class="float-right"><fa-icon class="obd-icon" [icon]="faSync"></fa-icon></a></div>
        <div class="obd-card-body">
          <div><label>High Engine Coolant Temperature</label> : {{engineCoolantTemperatureModel.highEngineCoolantTemperature}}</div>
          <div><label>Timestamp</label> : {{engineCoolantTemperatureModel.timestamp}}</div>
        </div> 
      </div>
    </div>
    <div class="col-lg-4 pr-lg-0 col-md-6">
      <div class="card">
        <div *ngIf="cardLoader8">
          <div class="loading">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
        <div class="obd-title">Speed <a (click)="refreshSpeed()" class="float-right"><fa-icon class="obd-icon" [icon]="faSync"></fa-icon></a></div>
        <div class="obd-card-body">
          <div><label>Speed</label> : {{speedModel.speed}}</div>
          <div><label>Speed Unit</label> : {{speedModel.speedUnit}}</div>
        </div> 
      </div>
    </div>
    <div class="col-lg-4 pr-lg-0 col-md-6">
      <div class="card">
        <div *ngIf="cardLoader9">
          <div class="loading">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
        <div class="obd-title">Rpm <a (click)="refreshRpm()" class="float-right"><fa-icon class="obd-icon" [icon]="faSync"></fa-icon></a></div>
        <div class="obd-card-body">
          <div><label>Error Message</label> : {{rpmModel.errorMessage}}</div>
        </div> 
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-4 col-md-6">
      <div class="card">
        <div *ngIf="cardLoader10">
          <div class="loading">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
        <div class="obd-title">Low Battery <a (click)="refreshLowBattery()" class="float-right"><fa-icon class="obd-icon" [icon]="faSync"></fa-icon></a></div>
        <div class="obd-card-body">
          <div><label>Battery Low Voltage</label> : {{lowBatteryModel.batteryLowVoltage}}</div>
          <div><label>Timestamp</label> : {{lowBatteryModel.timestamp}}</div>
        </div> 
      </div>
    </div>

    <div class="col-lg-4 pr-lg-0 col-md-6">
      
    </div>
    <div class="col-lg-4 pr-lg-0 col-md-6">
     
    </div>
  </div>
  
</div>